import { BenefitType } from '@/types/benefits/benefitTypes';
import CreateActivityPage from './CreateActivityPage';

const CreateMealPage = () => {
  return <CreateActivityPage type={BenefitType.MEAL} />;
};

export default CreateMealPage;
